// extracted by mini-css-extract-plugin
export var root = "box-list-module--root--P7xSl";
export var boxUl = "box-list-module--boxUl--Y-TLw";
export var boxLinkInvert = "box-list-module--boxLinkInvert--PLeuB";
export var boxUlCycle = "box-list-module--boxUlCycle--F0XU4";